const DashboardRoutes = {
  getCardsCount: "/getCardsCount",
};

export default DashboardRoutes;
